import { Grid, Box } from '@mui/material';
import { LogoAnchor, LogoHeader, MenuItem, TopMenu } from './common';
import MenuIcon from '../../../icons/Menu2';
import { styled } from '@mui/material/styles';

const HeaderWrapper = styled(Box)`
  background-color: transparent;
  width: 100%;
`;

const HeaderGrid = styled(Grid)`
  height: 100px;

  ${props => props.theme.breakpoints.up('md')} {
    background-color: inherit;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Header = ({ setDrawerState }) => {
  return (
    <HeaderWrapper>
      <header>
        <HeaderGrid pb={2} pt={2} pl={2.5} pr={2.5} container spacing={{ xs: 0 }}
                    justifyContent={'space-between'}
                    maxWidth={1440}
                    alignItems={'center'}>
          <Grid item>
          <LogoAnchor href={'/'}>
                  <LogoHeader src="/logo/PIXELS_white_logo.png" alt="Pixels Logo" />
                </LogoAnchor>
          </Grid>
          <Grid item>
            <MenuIcon onClick={() => setDrawerState(true)}/>
            <TopMenu>
              <MenuItem><a href={'https://blog.pixels.ai'}>Blog</a></MenuItem>
              {/* <MenuItem><a
                href={'https://pixelsai.notion.site/b65d2273ad9e41c9a66d2236a3e34fca?v=c648b2ab3d7346f581954fb04b1b5003'}>Product
                Centre</a></MenuItem></Grid> */}
              {/* <MenuItem><a href={'/case-studies/'}>Case Studies</a></MenuItem> */}
              <MenuItem><a href={'/contact/'}>Contact</a></MenuItem>
              <MenuItem><a href={`https://app${process.env.REACT_APP_ASSET_STAGE === 'dev' ? '-dev' : ''}.pixels.ai/`}>Login</a></MenuItem>
            </TopMenu>
          </Grid>
        </HeaderGrid>
      </header>
    </HeaderWrapper>
  );
};

export default Header;